import { Value } from '@nivo/bar';
import i18n from 'i18next';

export default function numericValueFormatter(value: Value): string {
    const number = Number.parseInt(value.toString());
    const formatted = Intl.NumberFormat(i18n.languages).format(number);
    return formatted;
}
